import React, { useEffect, useState } from 'react';
import BadgesComponent from '../../../components/common/Badges';
import CheckboxComponent from '../../../components/common/CheckBox';
import DataTable from '@components/common/CommonDataTable';
import SearchableDropdownComponent from '../../../components/common/SearchableDropDown';
import './overview.css';
import Copy from '../../../assets/svg/copy.svg';
import { stateList, districtList, blockList, villageList, wardList, ulbList, updateRoleDetails, userdetailsForUpdate, userEditCheckBoxes, FacilityList, userdetails, dateFormate } from './../../../constants';
import { useParams } from 'react-router-dom';
import endpoints from '../../../config/endpoints';
import { getData, getDataWithCache, putDataJSON } from '../../../services/CommonApiService';
import dayjs from 'dayjs';
import Button from '@components/common/Button';
import ClockIcon from '@assets/svg/clock-forward.svg';
import profilePic from '@assets/png/default_profile.png';
import UserFacilityModal from '@components/common/FacilityDetailsModal';
import convertByteToImageURL from '../../../utils/convertByteToImageURL';
import Collapse from 'react-bootstrap/Collapse';
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap';
import CardComponent from '@components/common/Cards';
import CommonCardComponent from '@components/common/CommonCardComponent';
import DownArrow from '@assets/svg/down-arrow.svg';
import UpArrow from '@assets/svg/up-arrow.svg';
import { useDispatch } from 'react-redux';
import { updateForm } from '@store/actions/userManagementAction';
import { setBeneficiaryAuthType } from '@store/actions/beneficiaryAction';
import Auth from './../../../utils/auth';
import LinkedUnLinkedShow from './linkedUnLinkedShow';
import { errorLogger } from '@utils/applicationLogUtils';
import isUsingGramPanchayatUtils from '@utils/isUsingGrampanchayatUtil';
import AadharModal from '../../Beneficiary-block/CreateBeneficiary/Aadhar';
import FaceAuthenticationModal from '../../Beneficiary-block/CreateBeneficiary/FaceAuthenticationModal';
import ReAuthenticateConfirmationModal from '../../Beneficiary-block/CreateBeneficiary/FaceAuthentication/ReAuthenticateConfirmationModal';
import UserReAuthenticationModal from './UserReAuthenticationModal';
import { toast } from 'react-toastify';
 
const stateOption = stateList.map(state => ({ value: `${state.stateNameEnglish} - ${state.stateCode}`, label: `${state.stateNameEnglish} - ${state.stateCode}` }));

interface objectType {
  user: any;
  flow: string;
  setUser: any;
  handleChange: (e:any, key:string) => void;
}

// const style = {
//   control : (baseStyle: any) => ({
//     ...baseStyle,
//     height: '30px'
//   }),
//   valueContainer: (baseStyle: any) => ({
//     ...baseStyle,
//     height: '30px',
//     // display: 'block',
//     // marginTop: '6px'
//   }),
// }

const OverView = (props: objectType) => {
  const { user, flow, handleChange,setUser } = props;
  const { id } = useParams();
  const copyToClipboard=(data:string)=>{
    
    navigator.clipboard.writeText(data);
  }
  
  const [userFormState, setuserFormState] = useState<any>({
    fName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    lName: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    user_type: {
      isError: false,
      message: '',
      id: '',
      code: undefined,
      isDisable: false,
      value: '',
    },
    designation: {
      isError: false,
      message: '',
      id: '',
      code: undefined,
      isDisable: false,
      value: '',

    },
    mob: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    a_mob: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    email: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    doj: {
      isError: false,
      message: '',
      isDisable: false,
      value: null,
    },
    hpr_abha_id: {
      isError: false,
      message: '',
      isDisable: true,
      value: 'NA',
    },
    user_status: {
      isError: false,
      message: '',
      isDisable: false,
      value: 'true',
    },
    user_id: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    effective_from_date: {
      isError: false,
      message: '',
      isDisable: true,
      value: '',
    },

  });
  const [roleFormState, setRoleFormState] = useState<any>({
    role_name: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
      id: '',
      code: undefined
    },
    state: {
      isError: false,
      message: '',
      isDisable: false,
      value: '-',
      id: '',
      code: undefined
    },
    zone_division: {
      isError: false,
      message: '',
      isDisable: false,
      value: '-',
      id: '',
      code: undefined
    },
    district: {
      isError: false,
      message: '',
      isDisable: false,
      value: '-',
      id: '',
      code: undefined
    },
    sub_district: {
      isError: false,
      message: '',
      isDisable: false,
      value: '-',
      id: '',
      code: undefined
    },
    sub_division: {
      isError: false,
      message: '',
      isDisable: false,
      value: '-',
      id: '',
      code: undefined
    },
    health_block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '-',
      id: '',
      code: undefined
    },
    rural_urban: {
      isError: false,
      message: '',
      isDisable: false,
      value: '-',
      id: '',
      code: undefined
    },
    block: {
      isError: false,
      message: '',
      isDisable: false,
      value: '-',
      id: '',
      code: undefined
    },
    village: {
      isError: false,
      message: '',
      isDisable: false,
      value: '-',
      id: '',
      code: undefined
    },
    gram_panchayat: {
      isError: false,
      message: '',
      isDisable: false,
      value: '-',
      id: '',
      code: undefined
    },
    ulb: {
      isError: false,
      message: '',
      isDisable: false,
      value: '-',
      id: '',
      code: undefined
    },
    ward: {
      isError: false,
      message: '',
      isDisable: false,
      value: '-',
      id: '',
      code: undefined
    },
  });
  const [checkBoxes, setCheckBoxes] = useState<any>({
    reportUserWithLineListingData: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
    offlineModeAccess: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
    mfa: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
    volunteerForPmsma: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    }
  })
  const [facilityHistory, setFacilityHistory] = useState<any>("")
  const [formStateForFacility, setFormStateForFacility] = useState<any>({
    hpr_id: {
      isError: false,
      message: '',
      isDisable: false,
      value: '',
    },
    health_facility_type: {
      isError: false,
      message: '',
      isDisable: false,
      value: 'NA',
      id:'',
      code:undefined
    },
    health_fName: {
      isError: false,
      message: '',
      isDisable: false,
      value: 'NA',
      id:'',
      code:undefined
    },
    mobiliser_tagged: {
      isError: false,
      message: '',
      isDisable: false,
      value: 'NA',
    },
    health_provider_tagged: {
      isError: false,
      message: '',
      isDisable: false,
      value: 'NA',
      id:'',
      code:undefined
    },
    volunteerForPmsma: {
      isError: false,
      message: '',
      isDisable: false,
      value: false,
    },
  });  
  const [userFormData, setUserFormData] = useState<any>(userdetailsForUpdate);
  const [roleFormData, setRoleFormData] = useState<any>(updateRoleDetails);
  const [checkBoxesFormData, setCheckBoxesFormData] = useState<any>(userEditCheckBoxes);
  const [facilityDetails,setFacilityDetails]=useState<any>([]);
  const [isFacilityField,setIsFacilityField]=useState<boolean>(false);
  const [isFieldOrFacilityUser,setIsFieldOrFacilityUser]=useState<boolean>(false);
  const [showReAuthConfirmModal, setShowReAuthConfirmModal] = useState<boolean>(false);
  const [showReAuthAadharModal, setShowReAuthAadharModal] = useState<boolean>(false);
  const [showReAuthFaceAuthModal, setShowReAuthFaceAuthModal] = useState<boolean>(false);
  const [showComparisonModal, setShowComparisonModal] = useState<boolean>(false);
  const [abdmData, setAbdmData] = useState<any>(null);
  const [userDetailsRaw, setUserDetailsRaw] = useState<any>(null);
  const [reverificationProcessId, setReverificationProcessId] = useState<string>('');
  const [dummyLinkedBenefDetails, setDummyLinkedBenefDetails] = useState<string>('');

  useEffect(() => {
    const fetchVerificationProcesses = async () => {
      try {
        const response = await getData<any>(`${endpoints.getVerificationProcess}`);
        if (response?.data) {
          const faceAuthProcess = response.data.find((p: any) => p.verification_process_code === 'FaceAuthentication');
          if (faceAuthProcess) {
            setReverificationProcessId(faceAuthProcess.verification_process_id);
          }
        }
      } catch (error: any) {
        errorLogger(error?.response?.data || error?.response || error);
      }
    };
    fetchVerificationProcesses();
  }, []);

  const handleReAuthClick = () => {
    const hasFaceAuthReverification =
      userDetailsRaw?.reverification_process_name === 'Face Authentication' &&
      (userDetailsRaw?.reverification_process_by_f_name ||
        userDetailsRaw?.reverification_process_by_l_name ||
        userDetailsRaw?.reverification_process_date);
    const hasFaceAuthVerification =
      userDetailsRaw?.verification_process_name === 'Face Authentication' &&
      (userDetailsRaw?.verification_process_by_f_name ||
        userDetailsRaw?.verification_process_by_l_name ||
        userDetailsRaw?.verification_process_date);
    if (hasFaceAuthReverification || hasFaceAuthVerification) {
      setShowReAuthConfirmModal(true);
    } else {
      dispatch(setBeneficiaryAuthType('Face_Auth_Creation'));
      setShowReAuthAadharModal(true);
    }
  };

  const handleReAuthConfirm = () => {
    dispatch(setBeneficiaryAuthType('Face_Auth_Creation'));
    setShowReAuthAadharModal(true);
  };

  const handleAadharReAuthClose = (type: string) => {
    setShowReAuthAadharModal(false);
    if (type === 'submit') {
      setShowReAuthFaceAuthModal(true);
    }
  };

  const handleFaceAuthReAuthClose = async (type: string, verifiedBeneficiaryData?: any) => {
    setShowReAuthFaceAuthModal(false);
    if (type === 'back') {
      dispatch(setBeneficiaryAuthType('Face_Auth_Creation'));
      setShowReAuthAadharModal(true);
    } else if (type === 'submit' && verifiedBeneficiaryData) {
      const abdmAbhaId = (verifiedBeneficiaryData?.abhaId || '').replace(/-/g, '');
      const userAbhaId = (userFormState.hpr_abha_id.value || '').replace(/-/g, '');

      const isAbhaMatch = abdmAbhaId === userAbhaId;
      if (isAbhaMatch) {
        // Update user with reverificationProcessId
        try {
          const data = {
            userId: id,
            fName: userDetailsRaw?.first_name || '',
            lName: userDetailsRaw?.last_name || '',
            email: userDetailsRaw?.email || '',
            mob: userDetailsRaw?.mob || '',
            oldMobileNumber: userDetailsRaw?.mob || '',
            userDesignationId: userDetailsRaw?.user_designation_id || '',
            doj: userDetailsRaw?.doj ? dayjs(userDetailsRaw.doj).format('YYYY-MM-DD') : null,
            userTypeId: userDetailsRaw?.usertype_id || '',
            mfa: userDetailsRaw?.mfa ?? false,
            volunteerForPmsma: userDetailsRaw?.volunteer_for_pmsma ?? false,
            userStatus: userDetailsRaw?.user_status || 'Active',
            reportUserWithLineListingData: userDetailsRaw?.report_user_with_line_listing_data ?? false,
            offlineModeAccess: userDetailsRaw?.offline_mode_access ?? false,
            stId: userDetailsRaw?.state_id || '',
            deletedZoneDivCircleId: [],
            insertedZoneDivCircleId: userDetailsRaw?.zone_div_circle_id || [],
            deletedCompositeRoleIds: [],
            insertedCompositeRoleIds: [],
            stCode: userDetailsRaw?.state_code || '',
            deletedRoleIds: [],
            insertedRoleIds: [],
            effectiveFromDt: userDetailsRaw?.effective_from_dt ? dayjs(userDetailsRaw.effective_from_dt).format('YYYY-MM-DD') : null,
            mName: userDetailsRaw?.middle_name || '',
            alternateMob: userDetailsRaw?.alternate_mob || '',
            abhaId: userDetailsRaw?.abha_id || '',
            hprId: userDetailsRaw?.hpr_id || '',
            distId: userDetailsRaw?.district_id || '',
            distCode: userDetailsRaw?.district_code || '',
            subDistId: userDetailsRaw?.sub_district_id || '',
            ulbId: userDetailsRaw?.ulb_id || '',
            blockId: userDetailsRaw?.block_id || '',
            healthBlockId: userDetailsRaw?.health_block_id || '',
            subDivisionId: userDetailsRaw?.sub_division_id || '',
            pcId: '',
            lacId: '',
            wardId: userDetailsRaw?.ward_id || '',
            villageId: userDetailsRaw?.village_id || '',
            facilityId: userDetailsRaw?.facility_id || '',
            urbanRuralId: userDetailsRaw?.urban_rual_id || '',
            parentUserId: '',
            parentUsertypeId: '',
            parentRoleId: '',
            imageData: '',
            url: '',
            description: '',
            isUsermasterChanged: true,
            isUserlocationChanged: false,
            isUserimageChanged: false,
            gramPanchayatId: userDetailsRaw?.gram_panchayat_id || '',
            consent_template_details: null,
            reverificationProcessId: reverificationProcessId ?? null,
          };
          await putDataJSON<any>(`${endpoints.updateUser(id)}`, data);
          toast.success('Re-authentication completed successfully.', { position: 'top-center' });
          try {
            const updatedUser = await getData<any[]>(`${endpoints.getUserById}/${id}`);
            if (updatedUser?.data?.[0]) {
              setUserDetailsRaw(updatedUser.data[0]);
            }
          } catch (refetchError: any) {
            errorLogger(refetchError?.response?.data || refetchError?.response || refetchError);
          }
        } catch (error: any) {
          toast.error('Failed to update re-authentication status.', { position: 'top-center' });
          errorLogger(error?.response?.data || error?.response || error, 'Re-Authentication - Update User');
        }
      } else {
        setAbdmData(verifiedBeneficiaryData);
        setShowComparisonModal(true);
      }
    }
  };
  const handleComparisonModalClose = (confirmed: boolean = false) => {
    setShowComparisonModal(false);
    if (!confirmed) {
      toast.warning('ASHA details mismatch detected. Please review.', { position: 'top-center' });
    }
    setAbdmData(null);
  };
  const [imageURL, setImageURL] = useState<string>('');
  const [isFacilityOrFieldUser, setIsFacilityOrFieldUser] = useState<string>('');
  const [isGrampanchayat,setIsGrampanchayat]=useState<boolean>(false);
  const [copied,setCopied]=useState<boolean>(false);
  const [copiedAMob,setCopiedAMob]=useState<boolean>(false);
  const formatDate = (dateString: string): string => {
    const [year, month, day] = dateString.split('-');
    return `${day}-${month}-${year}`;
  };
  const constructActionData = (dataList: any) => {
    return dataList.map((data: any) => {
      return {
        ...data,
        facility_name: data.facility_name !== null ? data.facility_name : '-----',
        facility_type_name:data.facility_type_name!==null?data.facility_type_name:'-----',
        hfr_id:data.hfr_id!==null?data.hfr_id:'-----',
        health_provider_name:data?.healthprovider_details!==null?data?.healthprovider_details?.map((hp:any) => hp?.healthprovider_name)?.join(', '):'-----',
        mobiliser_name:data?.mobiliser_details!==null?data?.mobiliser_details?.map((mb:any) => mb?.mobiliser_name)?.join(', '):'-----',
        effective_from_dt:data.effective_from_dt!==null?data.effective_from_dt:'-----',
        effective_to_dt:data.effective_to_dt!==null?data.effective_to_dt:'-----',
      };
    });
  };
  const dispatch=useDispatch();
  const [hprAbhaName,setHprAbhaName]=useState<string>("HPR ID/ ABHA Number");

  const [isFacilityDetailsVisible, setIsFacilityDetailsVisible] =  useState<any>(false);
  // userFormState.user_type.value === 'Facility Level User' || userFormState.user_type.value === 'Field Level User'

  const fetchLinkedFacilitiesInfo=async () =>{
    const facilityData=await getData<any[]>(`${endpoints.getActiveLinkedFacilitiesByUserId(id)}`);
    facilityData.data[0].forEach((item : any) => {
      item.effective_from_dt = item.effective_from_dt && dayjs(item.effective_from_dt).format('DD-MM-YYYY');
      item.effective_to_dt = item.effective_to_dt && dayjs(item.effective_to_dt).format('DD-MM-YYYY');
    });
    let filteredOverviewArr = [];
    filteredOverviewArr.push(constructActionData(facilityData.data[0]));
    filteredOverviewArr = filteredOverviewArr[0].filter((element: any) => {
      return element.is_parent;
    })
    setFacilityDetails( filteredOverviewArr);
  }

  useEffect(() => {
    setIsFacilityDetailsVisible(false);
    const fetchFacility = async () => {
      setIsFacilityDetailsVisible(false);
      try {
        const userDetail = await getData<any[]>(`${endpoints.getUserById}/${id}`);
        const userDetails = userDetail.data[0];
        setUserDetailsRaw(userDetails);
        if(userDetails?.usertype_name==='Facility Level User'){
          setIsFacilityOrFieldUser('Facility Level User');
        }
        else if(userDetails?.usertype_name==='Field Level User'){
          setIsFacilityOrFieldUser('Field Level User');
        }
        else{
          setIsFacilityOrFieldUser('');
        }
        if(userDetails?.state_code){
        try{
          setIsGrampanchayat(await isUsingGramPanchayatUtils(userDetails?.state_code));
        }
           catch(error:any){
              errorLogger(error?.response?.data||error?.response||error)
           }
      }
        setUser((userFormState: any) => ({
          ...userFormState,
          user_status: userDetail?.data?.[0]?.user_status
        }))

        if(userDetails.usertype_name==='Facility Level User'){
          if(userDetails.user_designation_name === 'MPW/MPHW'){
            setHprAbhaName("ABHA Number");
          } else {
            setHprAbhaName("HPR ID");
          }
          if(userDetails.user_designation_name === "Community Health Officer - CHO" ||userDetails.user_designation_name === "ANM"){
            setIsFieldOrFacilityUser(true);
          }
          else{
            setIsFieldOrFacilityUser(false);
          }
          setIsFacilityDetailsVisible(true);
          setIsFacilityField(true);
          fetchLinkedFacilitiesInfo();
        }
        else if(userDetails.usertype_name === 'Field Level User'){
          setHprAbhaName("ABHA Number");
          setIsFacilityDetailsVisible(true);
          if(userDetails.user_designation_name === "ASHA"){
            setIsFieldOrFacilityUser(true);
          }
          else{
            setIsFieldOrFacilityUser(false);
          }
          fetchLinkedFacilitiesInfo();
        }
        setuserFormState((userFormState: any) => ({
          ...userFormState,
          fName: {
            ...userFormState.fName,
            value: userDetails.first_name,
          },
          lName: {
            ...userFormState.lName,
            value: userDetails.last_name,
          },
          user_type: {
            ...userFormState.user_type,
            value: userDetails.usertype_name,
            id: userDetails.usertype_id,
            code: userDetails.usertype_code,
          },
          designation: {
            ...userFormState.designation,
            value: userDetails.user_designation_name,
            id: userDetails.user_designation_id,
            code: userDetails.user_designation_code,
          },
          mob: {
            ...userFormState.mob,
            value: userDetails.mob,
          },
          a_mob: {
            ...userFormState.a_mob,
            value: userDetails.alternate_mob,
          },
          email: {
            ...userFormState.email,
            value: userDetails.email,
          },
          doj: {
            ...userFormState.doj,
            value: formatDate(dayjs(userDetails.doj).format('YYYY-MM-DD')),
          },
          user_status: {
            ...userFormState.user_status,
            value: userDetails.user_status,
          },
          user_id: {
            ...userFormState.user_id,
            value: userDetails.mob,
          },
          effective_from_date: {
            ...userFormState.effective_from_date,
            value: formatDate(dayjs(userDetails.effective_from_dt).format('YYYY-MM-DD')),
          }
        }))

        const roles = await getData<any[]>(`${endpoints.getRoleByUserId(id)}`)
        const rolesValue = roles.data && roles.data.map((value: any) => value.role_name)?.join(", ");
        const rolesCode = roles.data && roles.data.map((value: any) => value.role_code);
        const rolesId = roles.data && roles.data.map((value: any) => value.role_id);
        const rolesOptions = roles.data.map((key: any) => ({
          value: key.role_name,
          label: key.role_name,
          id: key.role_id,
        }));
        dispatch(updateForm("userRoles",roles.data));
        const rolesByTypeId = await getDataWithCache<any[]>(`${endpoints.getAllRoles(userDetails.usertype_id,userDetails.user_designation_id)}`)

        const rolesByTypeIdOptions = rolesByTypeId.data.map((key: any) => ({
          value: key.role_name,
          label: key.role_name,
          id: key.role_id,
        }));
        setRoleFormData((role_details: any) => ({
          ...role_details,
          role_name: {
            ...role_details.role_name,
            '#options': rolesByTypeIdOptions,
          },
        }))
        setRoleFormState((roleFormState: any) => ({
          ...roleFormState,
          role_name: {
            ...roleFormState.role_name,
            value: rolesValue,
            id: rolesId,
            code: rolesCode,
          },
        }))

        if (userDetails.usertype_name === "Facility Level User") {
          setuserFormState((userFormState: any) => ({
            ...userFormState,
            hpr_abha_id: {
              ...userFormState.hpr_abha_id,
              value: userDetails.hpr_id,
            }
          }))
          // setFormStateForFacility((userFormState: any) => ({
          //   ...userFormState,
          //   mobiliser_tagged: {
          //     ...userFormState.mobiliser_tagged,
          //     value: "NA",
          //   },
          // }))
          setUserFormData((userFormState: any) => ({
            ...userFormState,
            hpr_abha_id: {
              ...userFormState.hpr_abha_id,
              '#isDisabled': false,
              '#title': 'HPR ID',

            }
          }))
        }
        else if (userDetails.usertype_name === "Field Level User") {
          setuserFormState((userFormState: any) => ({
            ...userFormState,
            hpr_abha_id: {
              ...userFormState.hpr_abha_id,
              value: userDetails.abha_id,
            }
          }))
          setUserFormData((userFormState: any) => ({
            ...userFormState,
            hpr_abha_id: {
              ...userFormState.hpr_abha_id,
              '#isDisabled': false,
              '#title': 'ABHA Number',
            }
          }))
          // try{
          // const healthProvider = await getData<any[]>(`${endpoints.getHealthProvTagByUserId}/${id}`)
          // const fistName = healthProvider.data && healthProvider.data.map((value: any) => value.first_name);
          // const lastName = healthProvider.data && healthProvider.data.map((value: any) => value.last_name);
          // const healthProviderCode = healthProvider.data && healthProvider.data.map((value: any) => value.health_provider_code);
          // const healthProviderId = healthProvider.data && healthProvider.data.map((value: any) => value.health_provider_id);
          // const name = fistName.join(", ");
          
          // setFormStateForFacility((userFormState: any) => ({
          //   ...userFormState,
          //   health_provider_tagged: {
          //     ...userFormState.health_provider_tagged,
          //     value: name,
          //     id: healthProviderId,
          //     code: healthProviderCode,
          //   },
          // }))
        
        // }
        // catch(error){
        // }
        }
        setRoleFormState((roleFormState: any) => ({
          ...roleFormState,
          state: {
            ...roleFormState.state,
            value: userDetails.state_name ? `${userDetails.state_name}-${userDetails.state_code}` : '-',
            id: userDetails.state_id,
            code: userDetails.state_code
          },
          district: {
            ...roleFormState.district,
            value: userDetails.district_name ? `${userDetails.district_name}-${userDetails.district_code}` : '-',
            id: userDetails.district_id,
            code: userDetails.district_code
          },
          sub_district: {
            ...roleFormState.sub_district,
            value: userDetails.sub_district_name ? `${userDetails.sub_district_name}-${userDetails.sub_district_code}` : '-',
            id: userDetails.sub_district_id,
            code: userDetails.sub_district_code
          },
          sub_division: {
            ...roleFormState.sub_division,
            value: userDetails.sub_division ? `${userDetails.sub_division}-${userDetails.sub_division_code}` : '-',
            id: userDetails.sub_division_id,
            code: userDetails.sub_division_code
          },
          health_block: {
            ...roleFormState.health_block,
            value: userDetails.health_block ? `${userDetails.health_block}-${userDetails.health_block_code}` : '-',
            id: userDetails.health_block_id,
            code: userDetails.health_block_code
          },
          rural_urban: {
            ...roleFormState.rural_urban,
            value: userDetails.urban_rural_name === 'rural' ? 'Rural' :userDetails.urban_rural_name ==='urban'? 'Urban':'-',
            id: userDetails.urban_rual_id,
            // code:userDetails.usertype_code,
          },
           zone_division: {
              ...roleFormState.zone_division,
              value: userDetails.zone_div_circle_name?userDetails.zone_div_circle_name[0]:'-',
              id: userDetails.zone_div_circle_id,
              code: userDetails.zone_div_circle_code
            },
        }))
        setCheckBoxes((roleFormState: any) => ({
          ...roleFormState,
          reportUserWithLineListingData: {
            ...roleFormState.reportUserWithLineListingData,
            value: userDetails.report_user_with_line_listing_data,
          },
          offlineModeAccess: {
            ...roleFormState.offlineModeAccess,
            value: userDetails.offline_mode_access,
          },
          mfa: {
            ...roleFormState.mfa,
            value: userDetails.mfa,
          },
          volunteerForPmsma: {
            ...roleFormState.volunteerForPmsma,
            value: userDetails.volunteer_for_pmsma,
          },

        }))
        if (userDetails.urban_rural_name === 'rural') {
          setRoleFormState((roleFormState: any) => ({
            ...roleFormState,
            block: {
              ...roleFormState.block,
              value: userDetails.block_name ? `${userDetails.block_name}-${userDetails.block_code}` : '-',
              id: userDetails.block_id,
              code: userDetails.block_code
            },
            village: {
              ...roleFormState.village,
              value: userDetails.village_name ? `${userDetails.village_name}-${userDetails.village_code}` : '-',
              id: userDetails.village_id,
              code: userDetails.village_code
            },
            gram_panchayat: {
              ...roleFormState.gram_panchayat,
              value: userDetails?.gram_panchayat_name ? `${userDetails?.gram_panchayat_name}-${userDetails?.gram_panchayat_code}` : '-',
              id:  userDetails?.gram_panchayat_id?userDetails?.gram_panchayat_id:'' ,
              code:  userDetails?.gram_panchayat_code?userDetails?.gram_panchayat_code:''
            },
          }))
        }
        else {
          setRoleFormState((roleFormState: any) => ({
            ...roleFormState,
            ulb: {
              ...roleFormState.ulb,
              value: userDetails.ulb_name ? `${userDetails.ulb_name}-${userDetails.ulb_code}` : '-',
              id: userDetails.ulb_id,
              code: userDetails.ulb_code
            },
            ward: {
              ...roleFormState.ward,
              value: userDetails.ward_name ? `${userDetails.ulb_name}-${userDetails.ulb_code} - ${userDetails.ward_name}-${userDetails.ward_code}` : '-',
              id: userDetails.ward_id,
              code: userDetails.ward_code
            },
          }))
        }
        //setting facility details
        setFormStateForFacility((userFormState: any) => ({
          ...userFormState,
          health_facility_type: {
            ...userFormState.health_facility_type,
            value: userDetails.facility_type_name,
            id: userDetails.facility_type_id
          },
          health_fName: {
            ...userFormState.health_fName,
            value: userDetails.facility_name,
            id: userDetails.facility_id,
            code: userDetails.facility_code
          },
          volunteerForPmsma: {
            ...userFormState.volunteerForPmsma,
            value: userDetails.volunteer_for_pmsma,
          }
        }))
      
        let linkedFacilityHistory: any[] = [];
        try{
          const linkFacHis = await getData<any[]>(`${endpoints.getLinkedFacilitiesHistoryByUserId(id)}`)
          
          linkedFacilityHistory = linkFacHis.data;
          
          const obj: { [key: string]: any[] } = {};
          linkedFacilityHistory.forEach((item) => {
            item.effective_from_dt = item.effective_from_dt && dayjs(item.effective_from_dt).format('DD-MM-YYYY');
            item.effective_to_dt = item.effective_to_dt && dayjs(item.effective_to_dt).format('DD-MM-YYYY');
          })
          for(let i=0;i<linkedFacilityHistory.length;i++){
            
            if(obj[`${linkedFacilityHistory[i].facility_name} / ${linkedFacilityHistory[i].facility_type_name} / ${linkedFacilityHistory[i].hfr_id}`]){
              obj[`${linkedFacilityHistory[i].facility_name} / ${linkedFacilityHistory[i].facility_type_name} / ${linkedFacilityHistory[i].hfr_id}`].push(linkedFacilityHistory[i])
            }
            else{
              const arr:any[] = []
              arr.push(linkedFacilityHistory[i]);
              obj[`${linkedFacilityHistory[i].facility_name} / ${linkedFacilityHistory[i].facility_type_name} / ${linkedFacilityHistory[i].hfr_id}`] = arr
            }
          }
          setFacilityHistory(obj);
        }
        catch(error:any){
          errorLogger(error?.response?.data||error?.response||error)
        }
      }
      catch(error:any){
        errorLogger(error?.response?.data||error?.response||error)
      }
      if(user && user.user_id) {
        await getData<any[]>(`${endpoints.getImageByUserID(user.user_id)}`).then((res) => {
          
          if(res?.data[0]) {
            const imageurl = convertByteToImageURL(res.data[0].image.data);
            setImageURL(imageurl);
          }
        }).catch((error) => {
          
        })
      }
    }
    fetchFacility();
  }, []);
  
  const [show,setShow]=useState<boolean>(false);
  const [verifyUser,setVerifyUser]=useState<boolean>(false);
  const handleClick=()=> {
    setShow(true);
    setVerifyUser(true);
  }
  const closeUserFacilityModal=()=>{
    setShow(false);
    setVerifyUser(false);
    setOpenItems({});
  }

 
  const [hstOpen, setHistOpen]=useState<boolean>(false)
  const keys = facilityHistory ? Object.keys(facilityHistory) : [];
  const histKey = keys.length > 0 ? keys[0].split("/") : [];
  const [openItems, setOpenItems] = useState<any>({});
  const handleFacHistoryList = (item : any) => {
    setOpenItems((prevOpenItems: { [x: string]: any; }) => ({
      ...prevOpenItems,
      [item]: !prevOpenItems[item],
    }));
  }; 

  const handleCheckLinkedFacility = (item: any) => {
    return facilityHistory[item].filter((ele: any) => ele.is_linked === true ).length > 0 ? 'linked' : 'unLinked';
  };

  const contents=(
  <div className='facility_details_history'>
     <div className='view-profile'>
              <img
                  className="profile-picture"
                  src={imageURL || profilePic}
                  alt="Profile Image"
                />
              <div className="name-type">
                <div className="name">{`${user.first_name.value}`}</div>
                <div className="type">{`${user.usertype_name} > ${user.roles}`}</div>
              </div>
              </div>
      <div className='facility-history-second-content'>
        <div className='fu-details-history-checkbox'>
              <CheckboxComponent
                className="fu-details-history-active"
                checkBoxName="Linked"
                disabled={true}
                onCheckboxChange={(value) => { handleChange(value, 'user_status ')}}
                placeCheckboxBefore={false}
              />
              <CheckboxComponent
                className="fu-details-history-inactive"
                checkBoxName="Unlinked"
                disabled={true}
                onCheckboxChange={(value) => { handleChange(value, 'user_status ')}}
                placeCheckboxBefore={false}
              />
        </div> 
        <div className='health-facilities-history-container'>
          <div className='history-facilities-list'>
            {
              
               keys.map((item: any)=>{
                 const [facility, facilityType,hfrId] = item.split('/').map((part :any) => part.trim());
                 const isHistOpen = openItems[item] || false;
                 return (            //hfr_id
                  <div key={item}>
                    <div className={`facility-item-container ${handleCheckLinkedFacility(item)}`} onClick={() => handleFacHistoryList(item)}>
                      <div className={`facility-item`}>
                        <div className='hf-name-value-css'><p className='hf-name'>Health Facility Name</p><p className='hf-name-type-semicolon'>:</p><p className='hf-name-value'>{facility}</p></div>
                        <div className='hf-name-type-value-css'><p className='hf-name-type'>Health Facility Type</p><p className='hf-name-type-semicolon'>:</p><p className='hf-type-value'>{facilityType}</p></div>
                        
    
                        {
                          openItems[item] === true ?
                          <div className='down-arrow-svg-css'><UpArrow className='down-arrow-svg' /></div>
                          :
                          <div className='down-arrow-svg-css'><DownArrow className='down-arrow-svg' /></div>
                        }
                      </div>
                      <div className='facility-item2'>
                        <div className='hf-id-type-value-css'><p className='hf-id-facility'>HFR ID</p><p className='hf-id-type-semicolon'>:</p><p className='hf-id-value'>{hfrId}</p></div>
                        </div>
                        {
                          facilityHistory[item].map((data:any)=>(
                              <Collapse in={isHistOpen} key={data}>
                                  <div className={`card-facility-history`}>
                                    {
                                    data.is_linked === true ? <div className='card-facility-history-active'>
                                    <CommonCardComponent cardBodyContent={
                                      <div className='card-fac-actv-css'>
                                        {/* <div className='card-ef-frm-dt'> */}
                                          <p className='card-ef-frm-dt-name'>Effective From Date</p><p className='card-ef-frm-dt-name-value'>{data.effective_from_dt === null ? '-  -  -  -  - ' : data.effective_from_dt}</p>
                                          {/* </div>
                                        <div className='card-ef-to-dt'> */}
                                          <p className='card-ef-to-dt-name'>Effective To Date</p><p className='card-ef-to-dt-name-value'>{data.effective_to_dt === null ? '-  -  -  -  - ' : data.effective_to_dt}</p>
                                        {/* </div>
                                        <div className='card-ef-mob-tag'> */}
                                           <p className='card-ef-mob-tag-name'>{isFacilityOrFieldUser === "Facility Level User" ? 'Asha/Mobiliser Tagged' : 'ANM/ Health Provider'}</p>
                                           <p className='card-ef-mob-tag-name-value'>{data.healthprovider_details === null ? (data.mobiliser_details !== null ? data.mobiliser_details.map((mb:any)=>mb.mobiliser_name).join(', ') : '-  -  -  -  - '):data.healthprovider_details.map((hp:any)=>hp.healthprovider_name).join(', ')}</p>
                                        {/* </div>
                                        <div className='card-ef-rem'> */}
                                          <p className='card-ef-rem-name'>Remarks</p><p className='card-ef-rem-name-value'>{data.remarks === null ? '-  -  -  -  - ' : data.remarks}</p>
                                        {/* </div> */}
                                      </div>
                                    } />
                                </div>:
                                <div className='card-facility-history-inactive'>
                                <CommonCardComponent cardBodyContent={
                                  <div className='card-fac-inactv-css'>
                                      {/* <div className='card-ef-frm-dt'> */}
                                          <p className='card-ef-frm-dt-name'>Effective From Date</p><p className='card-ef-frm-dt-name-value'>{data.effective_from_dt === null ? '-  -  -  -  - ' : data.effective_from_dt}</p>
                                          {/* </div>
                                        <div className='card-ef-to-dt'> */}
                                          <p className='card-ef-to-dt-name'>Effective To Date</p><p className='card-ef-to-dt-name-value'>{data.effective_to_dt === null ? '-  -  -  -  - ' : data.effective_to_dt}</p>
                                        {/* </div>
                                        <div className='card-ef-mob-tag'> */}
                                        {/* </div>
                                        <div className='card-ef-rem'> */}
                                          <p className='card-ef-rem-name'>Remarks</p><p className='card-ef-rem-name-value'>{data.remarks === null ? '-  -  -  -  - ' : data.remarks}</p>
                                        {/* </div> */}
                                  </div>
                                } />
                              </div>
                                    }
                                    
                                  </div>
                              </Collapse>
                          ))
                        }
                      </div>
                  </div>
                  );
                })
            }
          </div>
        </div>
      </div>
      </div>
    )
  return (
    <>
      <div className="overview_user">
        <BadgesComponent
          className="over-badge"
          badgeName="User Details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details">
          <div>
            <label className="overview-details-label">First Name</label>
            <div className="overview-details-value">{flow==='view'?<>{userFormState.fName.value}</>
            :''

            }
            </div>
          </div>
          <div>
            <label className="overview-details-label">Last Name</label>
            <div className="overview-details-value">{flow==='view'?<>{userFormState.lName.value}</>
            :''
           
            }</div>
          </div>
          <div>
            <label className="overview-details-label">Email</label>
            <div className="overview-details-value">
              {flow === 'view' ? <div>{userFormState.email.value? (<div>{userFormState.email.value}
                 {/* <button
                onClick={()=>{navigator.clipboard.writeText(userFormState.email.value)}}
                style={{backgroundColor:"white",color:"black",borderColor:"white",border:"1px"}}
              >{<Copy style={{color:"black"}}/>}</button> */}
              </div>):('NA')}</div> : ""
              
              }
            </div>
          </div>
          <div>
          <label className="overview-details-label">Mobile Number(User ID)</label>
<div className="overview-details-value">
  {flow === 'view' ? (
    <div>
      {userFormState.mob.value ? (
        <div>
          {userFormState.mob.value}
          <button
            onClick={() => {
              //it will work only in https so for temporary we are uncommenting and using once server runs in https meanwhile we can use bottom snippet
              //navigator.clipboard.writeText(userFormState.mob.value);

              //need to remove once we are in https 
              const textArea = document.createElement("textarea");
              textArea.value = userFormState.mob.value;
              document.body.appendChild(textArea);
              textArea.focus();
              textArea.select();
              try {
                document.execCommand('copy');
              } catch(error:any){
                   errorLogger(error?.response?.data||error?.response||error)
                }
              document.body.removeChild(textArea);
              setCopied(true);
              setTimeout(() => setCopied(false), 2000); // Reset the copied state after 2 seconds
            }}
            style={{marginLeft:"5px", backgroundColor: "white", color: "black", borderColor: "white", border: "1px" }}
          >
            <Copy style={{ color: "black" }} />
          </button>
          {copied && <span style={{ marginLeft: "10px", color: "black"  }}>Copied!</span>}
        </div>
      ) : (
        'NA'
      )}
    </div>
  ) : (
    ''
  )}
</div>

          </div>
          <div>
            <label className="overview-details-label">
              Alternate Mobile Number
            </label>
            <div className="overview-details-value">
              {flow === 'view' ? <div>{userFormState.a_mob.value? (<div>{userFormState.a_mob.value} 
                <button
            onClick={() => {
              // navigator.clipboard.writeText(userFormState.a_mob.value);
              const textArea = document.createElement("textarea");
              textArea.value = userFormState.a_mob.value;
              document.body.appendChild(textArea);
              textArea.focus();
              textArea.select();
              try {
                document.execCommand('copy');
              }  catch(error:any){
                      errorLogger(error?.response?.data||error?.response||error)
                }
              document.body.removeChild(textArea);
              setCopiedAMob(true);
              setTimeout(() => setCopiedAMob(false), 2000); // Reset the copied state after 2 seconds
            }}
            style={{ marginLeft:"5px",backgroundColor: "white", color: "black", borderColor: "white", border: "1px" }}
          >
            <Copy style={{ color: "black" }} />
          </button>
          {copiedAMob && <span style={{ marginLeft: "10px", color: "black"  }}>Copied!</span>}</div>):('NA')}
              </div> : 
             '-'
              }
            </div>
          </div>
          <div>
            <label className="overview-details-label">Designation</label>
            <div className="overview-details-value">{userFormState.designation.value}</div>
          </div>
          <div>
            <label className="overview-details-label">Date of Registration on JANANI</label>
            <div className="overview-details-value">{userFormState.doj.value}</div>
          </div>
          <div>
            <label className="overview-details-label">User Type</label>
            <div className="overview-details-value">{userFormState.user_type.value}</div>
          </div>
   
          <div>
            <label className="overview-details-label">{hprAbhaName}</label>
            <div className="overview-details-value abha-value-container">
              <span>{userFormState.hpr_abha_id.value}</span>
              {userFormState.hpr_abha_id.value && (userDetailsRaw?.verification_process_name === 'Face Authentication' || userDetailsRaw?.reverification_process_name === 'Face Authentication') && (
                <>
                  {(() => {
                    const authDate = userDetailsRaw?.reverification_process_date || userDetailsRaw?.verification_process_date;
                    const authBy = (userDetailsRaw?.reverification_process_by_f_name || userDetailsRaw?.reverification_process_by_l_name)
                      ? `${userDetailsRaw?.reverification_process_by_f_name || ''} ${userDetailsRaw?.reverification_process_by_l_name || ''}`.trim()
                      : `${userDetailsRaw?.verification_process_by_f_name || ''} ${userDetailsRaw?.verification_process_by_l_name || ''}`.trim();
                    return authDate || authBy ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="user-auth-info-tooltip">
                            <div className="user-auth-tooltip-content">
                              <div className="user-auth-tooltip-row"><strong>Authenticated By:</strong> {authBy || 'N/A'}</div>
                              <div><strong>Authentication Date:</strong> {authDate ? dayjs(authDate).format(`${dateFormate.dd_mm_yyyy} ${dateFormate.hh_mm_A}`) : 'N/A'}</div>
                            </div>
                          </Tooltip>
                        }
                      >
                        <i className="bi bi-info-circle user-auth-info-icon"></i>
                      </OverlayTrigger>
                    ) : null;
                  })()}
                  <div className="verified">Authenticated</div>
                </>
              )}
            </div>
            {flow === 'view' && isFieldOrFacilityUser && userFormState.hpr_abha_id.value && userDetailsRaw?.usertype_name === 'Field Level User' && userDetailsRaw?.user_designation_name === 'ASHA' && (
              <button className="re-authenticate-btn" onClick={handleReAuthClick}>
                Re-authenticate
              </button>
            )}
          </div>
          <div>
            <label className="overview-details-label">User Status</label>
            <div className="overview-details-value">
              {
                userFormState.user_status.value
              }
            </div>
          </div>
          <div>
            <label className="overview-details-label">Effective From Date</label>
            <div className="overview-details-value">
              {
                userFormState.effective_from_date.value??'-'
              }
            </div>
          </div>
        </div>
      </div>
      <div className="overview_user">
        <BadgesComponent
          className="over-badge"
          badgeName="Role and location details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details">
          <div>
            <label className="overview-details-label">Role</label>
            <div className="overview-details-value">
              {
                 roleFormState.role_name.value
             }
            </div>
          </div>
          <div>
            <label className="overview-details-label">State</label>
            <div className="overview-details-value">
              {
                 roleFormState.state.value??'-'
             }
            </div>
          </div>
          <div>
            <label className="overview-details-label">Zone/Division/Circle</label>
            <div className="overview-details-value">
              {
                 roleFormState.zone_division.value??'-'
             }
            </div>
          </div>
          <div>
            <label className="overview-details-label">District</label>
            <div className="overview-details-value">
              {
                 roleFormState.district.value??'-'
              }
            </div>
          </div>
          <div>
            <label className="overview-details-label">Rural/Urban</label>
            <div className="overview-details-value">
              {
                 roleFormState.rural_urban.value??'-'
              }
            </div>
          </div>
          <div>
            <label className="overview-details-label">ULB</label>
            <div className="overview-details-value">
              {roleFormState.ulb.value ??'-'
              }
            </div>
          </div>
          <div>
            <label className="overview-details-label">Sub-District</label>
            <div className="overview-details-value">
              {roleFormState.sub_district.value??'-'
              }
            </div>
          </div>
          <div>
            <label className="overview-details-label">Block</label>
            <div className="overview-details-value">
              {
                roleFormState.block.value??'-'
              }
            </div>
          </div>
          <div>
            <label className="overview-details-label">Health Block</label>
            <div className="overview-details-value">
              {
                roleFormState.health_block.value??'-'
              }
            </div>
          </div>
          <div>
            <label className="overview-details-label">Sub-Division</label>
            <div className="overview-details-value">
              {
                roleFormState.sub_division.value??'-'
              }
            </div>
          </div>
          <div>
            <label className="overview-details-label">{isGrampanchayat?'Gram Panchayat / ADC Village':'Village'}</label>
            <div className="overview-details-value">
              {
                isGrampanchayat? roleFormState.gram_panchayat.value??'-':roleFormState.village.value??'-'
              }
            </div>
          </div>
          <div>
            <label className="overview-details-label">Ward</label>
            <div className="overview-details-value">
              { roleFormState.ward.value ??'-'
              }
            </div>
          </div>
        </div>
      </div>
      {
       isFacilityDetailsVisible &&   <div className="overview_user">
        <div className='user_view_facility_badge_button'>
       <BadgesComponent
         className="over-badge"
         badgeName="Parent facility Details"
         variant="primary-1"
         badgeType="case5"
       />
        <Button
            onClick={handleClick}
            disabled={false}
            id="user_view_facility_button"
            buttonName={'View Facility Details'}
            colorType={'primary'}
            icon={<ClockIcon/>}
            iconPosition={'left'}
          />
       </div>
        {verifyUser && <UserFacilityModal
          contents={contents} title={'Facility History'} closeModal={closeUserFacilityModal} showModal={show} />
        }
       <div className="overview-details-table">
         
       {user.usertype_name==='Facility Level User'&& <div className='user_mana'>
         <DataTable

           data={facilityDetails}
           itemsPerPage={[10, 20, 30, 40, 50]}
           pagination={facilityDetails.length > 10}
           searchTerm={''}
          //  height={'50px'}
           columnHeader={[
             {
               name: 'Health Facility Type',
               key: 'facility_type_name',
               sortable: true,
             },
             {
               name: 'Health Facility Name',
               key: 'facility_name',
               sortable: true,
             },
             {
               name: 'Asha/ Mobiliser Tagged',
               key: 'mobiliser_name',
               sortable: true,
             },
             {
              name: 'Effective From Date',
              key: 'effective_from_dt',
              sortable: true,
            },
            {
              name: 'Effective To Date',
              key: 'effective_to_dt',
              sortable: true,
            },
             
           ]} gridFor={"healthProvider"} />
       </div>}
       {
        user.usertype_name!=='Facility Level User'&& <div className='user_mana'>
        <DataTable

// data={[
//   {
//     'Health Facility Type': formStateForFacility.health_facility_type.value?formStateForFacility.health_facility_type.value:'NA',
//     'Health Facility Name': formStateForFacility.health_fName.value?formStateForFacility.health_fName.value:'NA',
//     'Health Provider Tagged': formStateForFacility.health_provider_tagged.value?formStateForFacility.health_provider_tagged.value:'NA',
//   },
// ]}
data={facilityDetails}
itemsPerPage={[10, 20, 30, 40, 50]}
pagination={false}
searchTerm={''}
height={'50px'}
columnHeader={[
  {
    name: 'Health Facility Type',
    key: 'facility_type_name',
    sortable: true,
  },
  {
    name: 'Health Facility Name',
    key: 'facility_name',
    sortable: true,
  },
  {
    name: 'ANM/ Health Provider Tagged',
    key: 'health_provider_name',
    sortable: true,
  },
  
]} gridFor={""} />
      </div>
       }
       </div>
     </div>
      }
      <div className="overview_user">
        <BadgesComponent
          className="over-badge"
          badgeName="Other details"
          variant="primary-1"
          badgeType="case5"
        />
        <div className="overview-details">
          <CheckboxComponent
            className="cb-overview-report"
            checkBoxName="Report user with line listing data"
            disabled={true}
            onCheckboxChange={(value) => { handleChange(value, 'reportUserWithLineListingData')}}
            placeCheckboxBefore={false}
            isChecked={checkBoxes.reportUserWithLineListingData.value}
          />
          <CheckboxComponent
            className="cb-multi-factor"
            checkBoxName="Multi-factor Authentication"
            disabled={true}
            onCheckboxChange={(value) => { handleChange(value, 'mfa')}}
            placeCheckboxBefore={false}
            isChecked={checkBoxes.mfa.value}
          />
         {isFacilityField && <CheckboxComponent
            className="cb-volunteer-pmsma"
            checkBoxName="Volunteer for PMSMA"
            disabled={true}
            onCheckboxChange={(value) => { handleChange(value, 'volunteerForPmsma')}}
            placeCheckboxBefore={false}
            isChecked={checkBoxes.volunteerForPmsma.value}
          />}
          {isFieldOrFacilityUser &&<CheckboxComponent
            className="cb-offline-mode"
            checkBoxName="Offline Mode Access"
            disabled={true}
            onCheckboxChange={(value) => { handleChange(value, 'offlineModeAccess')}}
            placeCheckboxBefore={false}
            isChecked={checkBoxes.offlineModeAccess.value}
          />}
        </div>
      </div>
      <Modal
        show={showReAuthAadharModal}
        centered
        onHide={() => handleAadharReAuthClose('')}
        backdrop={true}
        keyboard={true}
        dialogClassName="re-auth-aadhar-modal"
      >
        <Modal.Header>
          <div className="re-auth-modal-header-content">
            <div className="d-flex align-items-center beneficiary_discard_button re-auth-discard-btn" onClick={() => handleAadharReAuthClose('')}>
              <span className="me-0">Discard</span>
              <i className="bi bi-x"></i>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <AadharModal
            handleClose={handleAadharReAuthClose}
            setLinkedBenefDetails={setDummyLinkedBenefDetails}
          />
        </Modal.Body>
      </Modal>
      {showReAuthFaceAuthModal && (
        <FaceAuthenticationModal
          showModal={showReAuthFaceAuthModal}
          handleClose={handleFaceAuthReAuthClose}
          skipGenderCheck={true}
        />
      )}
      <ReAuthenticateConfirmationModal
        showModal={showReAuthConfirmModal}
        setShowModal={setShowReAuthConfirmModal}
        onConfirm={handleReAuthConfirm}
        authenticationDate={
          userDetailsRaw?.reverification_process_date ||
          userDetailsRaw?.verification_process_date
        }
        authenticatedBy={
          (userDetailsRaw?.reverification_process_by_f_name || userDetailsRaw?.reverification_process_by_l_name)
            ? `${userDetailsRaw?.reverification_process_by_f_name || ''} ${userDetailsRaw?.reverification_process_by_l_name || ''}`.trim()
            : `${userDetailsRaw?.verification_process_by_f_name || ''} ${userDetailsRaw?.verification_process_by_l_name || ''}`.trim()
        }
      />
      <UserReAuthenticationModal
        showModal={showComparisonModal}
        handleClose={handleComparisonModalClose}
        userData={{
          abhaNumber: userFormState.hpr_abha_id.value || ''
        }}
        abdmData={abdmData}
      />
    </>
  );
};
export default OverView;
